import { Box, Divider, useTheme } from '@mui/material';
import Header from '../../modules/dashboard/components/Header';
import Sidebar from '../../modules/dashboard/components/Sidebar';
import type { ReactNode } from 'react';
import { TenantProvider } from '../../modules/tenant/context/TenantContext';

interface AuthenticatedLayoutProps {
  children: ReactNode;
}

const AuthenticatedLayout = ({ children }: AuthenticatedLayoutProps) => {
  const theme = useTheme();

  return (
    <Box display="flex" minHeight="100vh" bgcolor={theme.palette.background.default}>
      <Sidebar />
      <Box flex={1} display="flex" flexDirection="column">
        <Header />
        <Box
          component="main"
          flex={1}
          px={{ xs: 1, md: 4 }}
          py={3}
          width="100%"
          maxWidth="100vw"
          overflow="auto"
        >
          {children}
        </Box>
        <Divider sx={{ mt: 2 }} />
        <Box p={2} textAlign="center" color="grey.600" fontSize={14}>
          ERP SaaS Demo © 2025 - Todos os direitos reservados
        </Box>
      </Box>
    </Box>
  );
};

export default AuthenticatedLayout;